import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtCurrency, fmtDate } from "@/lib/format";
import { eiStatus, openInvoicePdf, PAY_STATUS, payLabel } from "@/lib/invoices";
import { Panel, SectionLabel, StatusBadge } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { ReminderDialog } from "@/components/billing/ReminderDialog";

export const CompanyInvoicesPanel = ({ companyId }) => {
  const [items, setItems] = useState([]);
  const [can, setCan] = useState(false);
  const [rem, setRem] = useState(null);
  const load = () => api.get("/fic/invoices", { params: { company_id: companyId } }).then((r) => { setItems(r.data.items); setCan(r.data.can_invoice); }).catch(() => setItems([]));
  useEffect(() => { load(); }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items.length) return null;
  return (
    <Panel className="p-5" data-testid="company-invoices-panel">
      <SectionLabel>Fatture emesse</SectionLabel>
      <ul className="mt-3 divide-y divide-line">{items.slice(0, 8).map((inv) => {
        const [label, tone] = eiStatus(inv.status === "bozza" ? null : inv.ei_status);
        return (
          <li key={inv.id} className="flex items-center gap-2 py-2 text-sm" data-testid={`company-invoice-${inv.id}`}>
            <button type="button" onClick={() => openInvoicePdf(inv)} className="min-w-0 flex-1 truncate text-left font-medium text-ink hover:text-brand-600">{inv.number} · {fmtDate(inv.date)}</button>
            <StatusBadge tone={tone}>{label}</StatusBadge>
            {payLabel(inv) && <StatusBadge tone={PAY_STATUS[inv.payment_status][1]}>{payLabel(inv)}</StatusBadge>}
            {can && inv.status === "inviata" && inv.payment_status === "scaduta" && <Button size="sm" variant="ghost" className="h-7 px-2 text-xs text-red-700" onClick={() => setRem(inv)} data-testid={`company-invoice-remind-${inv.id}`}>Sollecita</Button>}
            <span className="w-24 text-right">{fmtCurrency(inv.taxable)}</span>
          </li>);
      })}</ul>
      <ReminderDialog inv={rem} onClose={() => setRem(null)} onSent={load} />
    </Panel>
  );
};
